var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.isLoading)?_c('p',[_vm._v("Loading...")]):_vm._e(),(!_vm.isLoading)?_c('edit-bot-form',{attrs:{"model":_vm.model,"market_pairs":_vm.market_pairs}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }